var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hosityheader"},[_c('ul',{staticClass:"ullist"},[_c('li',[_vm._v("购买日期")]),_vm._v(" "),_c('li',[_vm._v("购买人")]),_vm._v(" "),_c('li',[_vm._v("购买个数")]),_vm._v(" "),_c('li',[_vm._v("支付金额")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae9ae5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acount/PurchaseHistory.vue
// module id = null
// module chunks = 